import React from "react";

// --- Inline Icons (lucide-like minimal SVGs) ---
const ArrowRight = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-4 h-4 " + (props.className || "")}>
    <path d="M5 12h14" /><path d="M13 5l7 7-7 7" />
  </svg>
);
const Check = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-5 h-5 text-teal-500 " + (props.className || "")}>
    <path d="M20 6L9 17l-5-5" />
  </svg>
);
const Shield = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-5 h-5 text-indigo-500 " + (props.className || "")}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);
const Database = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-5 h-5 text-indigo-500 " + (props.className || "")}>
    <ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M3 5v6c0 1.657 4.03 3 9 3s9-1.343 9-3V5" /><path d="M3 11v6c0 1.657 4.03 3 9 3s9-1.343 9-3v-6" />
  </svg>
);
const Zap = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-5 h-5 text-indigo-500 " + (props.className || "")}>
    <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
  </svg>
);
const BookOpen = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-5 h-5 text-indigo-500 " + (props.className || "")}>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M20 22V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16" />
  </svg>
);
const Compare = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinecap="round" className={"w-5 h-5 text-indigo-500 " + (props.className || "")}>
    <path d="M10 3H5a2 2 0 0 0-2 2v5h7V3z" />
    <path d="M21 14h-7v7h5a2 2 0 0 0 2-2v-5z" />
    <path d="M3 10h7" /><path d="M14 14h7" />
  </svg>
);
const Stars = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-5 h-5 text-indigo-500 " + (props.className || "")}>
    <path d="M12 2l2.9 6 6.6.6-5 4.3 1.6 6.4L12 16l-6.1 3.3L7.5 13 2.1 8.6l6.6-.6z" />
  </svg>
);

// --- Icons8 Icons for KPI section ---
const BoltIcon = (props) => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-12 h-12 " + (props.className || "")}>
    <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z"></path>
  </svg>
);

const AgreementIcon = (props) => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-12 h-12 " + (props.className || "")}>
    <path d="M12 19V5M5 12l7-7 7 7"></path>
    <rect x="2" y="10" width="20" height="12" rx="2" ry="2" />
    <path d="M16 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h2" />
  </svg>
);

const ReduceCyclesIcon = (props) => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-12 h-12 " + (props.className || "")}>
    <path d="M12 5V19M19 12l-7 7-7-7"></path>
    <path d="M21 12a9 9 0 1 1-9-9c2.47 0 4.7 1.12 6.18 2.9L21 3"></path>
  </svg>
);

const ReuseIcon = (props) => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-12 h-12 " + (props.className || "")}>
    <path d="M17 1l4 4-4 4"></path>
    <path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
    <path d="M7 23l-4-4 4-4"></path>
    <path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
  </svg>
);

const AuditReadyIcon = (props) => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-12 h-12 " + (props.className || "")}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    <path d="M9 12l2 2 4-4"></path>
  </svg>
);

// --- Icons8 Icons for How It Works section ---
const FactoryIcon = (props) => ( // Step 1: Choose Factory
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-16 h-16 " + (props.className || "")}>
    <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
  </svg>
);

const InputConfigIcon = (props) => ( // Step 2: Set Inputs
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-16 h-16 " + (props.className || "")}>
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
    <line x1="8" y1="21" x2="16" y2="21"></line>
    <line x1="12" y1="17" x2="12" y2="21"></line>
    <polyline points="10 9 9 10 12 13 15 10 14 9"></polyline> {/* Data flow icon */}
  </svg>
);

const ProcessExportIcon = (props) => ( // Step 3: Run -> Approve -> Export
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"w-16 h-16 " + (props.className || "")}>
    <polygon points="5 3 19 12 5 21 5 3"></polygon> {/* Play icon */}
    <path d="M22 11V3h-8"></path>
    <path d="M22 3L11 14"></path>
  </svg>
);


// --- New components for the redesign ---
const HeroVideoMockup = () => (
  <div className="relative w-full aspect-[16/9] rounded-2xl bg-gray-900 overflow-hidden shadow-2xl">
    <div className="absolute inset-0 z-10 p-4 sm:p-6 lg:p-8 flex items-center justify-center">
      <div className="text-white/50 text-center">
        <div className="w-16 h-16 rounded-full border-2 border-white/20 flex items-center justify-center mx-auto mb-2">
          <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 3l14 9-14 9V3z" />
          </svg>
        </div>
        <p className="text-sm">Placeholder for product demo video loop</p>
      </div>
    </div>
  </div>
);

// --- Small Primitives ---
const Badge = ({ children }) => (
  <span className="inline-flex items-center rounded-full border border-gray-300 px-3 py-1 text-xs font-medium text-gray-700">{children}</span>
);
const Pill = ({ children }) => (
  <span className="inline-flex items-center rounded-full bg-indigo-600 text-white px-3 py-1 text-xs font-medium">{children}</span>
);
const CTAButton = ({ children, href = "#", variant = "primary", testid }) => {
  const base = "inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all";
  const styles = variant === "primary"
    ? "bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-indigo-500 shadow-lg"
    : "bg-white text-gray-900 border border-gray-300 hover:bg-gray-50 focus:ring-gray-300";
  return (
    <a data-testid={testid} href={href} className={`${base} ${styles}`}>
      {children}
      <ArrowRight />
    </a>
  );
};

const Card = ({ title, icon, children, footer, testid }) => (
  <div data-testid={testid} className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm hover:shadow-md transition-shadow">
    <div className="flex items-center gap-2 mb-2">
      {icon}
      <h3 className="text-base font-semibold text-gray-900">{title}</h3>
    </div>
    <div className="text-sm text-gray-700 leading-6">{children}</div>
    {footer && <div className="mt-3 text-sm text-gray-600">{footer}</div>}
  </div>
);

// --- Testimonials and Logos (Made up for now) ---
const Testimonial = ({ quote, author }) => (
  <blockquote data-testid="quote" className="rounded-2xl border border-gray-200 p-6 bg-white shadow-sm">
    <p className="text-lg font-medium text-gray-800">“{quote}”</p>
    <p className="mt-4 text-sm font-semibold text-indigo-600">— {author}</p>
  </blockquote>
);

const ClientLogos = () => (
  <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6 items-center justify-center">
    <div className="h-8 md:h-10 text-gray-400 opacity-60 hover:opacity-100 transition"><svg viewBox="0 0 100 24" fill="currentColor"><path d="M50 0L42.5 14.6l-15.5 0L35 0h-10L17.5 14.6L2.5 0H0L15 24h10L15 9.4L27.5 24h10z" /></svg></div>
    <div className="h-8 md:h-10 text-gray-400 opacity-60 hover:opacity-100 transition"><svg viewBox="0 0 100 24" fill="currentColor"><path d="M100 12c0 6.6-5.4 12-12 12s-12-5.4-12-12 5.4-12 12-12 12 5.4 12 12zM76 12c0-2.2-1.8-4-4-4s-4 1.8-4 4 1.8 4 4 4 4-1.8 4-4z" /></svg></div>
    <div className="h-8 md:h-10 text-gray-400 opacity-60 hover:opacity-100 transition"><svg viewBox="0 0 100 24" fill="currentColor"><path d="M0 0h100v24h-100z" /></svg></div>
    <div className="h-8 md:h-10 text-gray-400 opacity-60 hover:opacity-100 transition"><svg viewBox="0 0 100 24" fill="currentColor"><path d="M50 0c-13.8 0-25 11.2-25 25h50c0-13.8-11.2-25-25-25z" /></svg></div>
    <div className="h-8 md:h-10 text-gray-400 opacity-60 hover:opacity-100 transition"><svg viewBox="0 0 100 24" fill="currentColor"><path d="M0 0h24v24h-24z" /></svg></div>
    <div className="h-8 md:h-10 text-gray-400 opacity-60 hover:opacity-100 transition"><svg viewBox="0 0 100 24" fill="currentColor"><path d="M0 0h24v24h-24z" /></svg></div>
  </div>
);

const KPICard = ({ icon: Icon, title, description, testid, iconColorClass }) => (
  <div data-testid={testid} className="rounded-2xl border border-gray-200 p-6 bg-white shadow-sm text-center flex flex-col items-center justify-center h-full">
    <div className={`mb-4 ${iconColorClass}`}>
      <Icon />
    </div>
    <h3 className="text-xl font-semibold text-gray-900 mb-1">{title}</h3>
    <p className="text-sm text-gray-600">{description}</p>
  </div>
);

const HowItWorksStep = ({ number, icon: Icon, title, description, iconColorClass, testid }) => (
  <div data-testid={testid} className="flex flex-col items-center text-center p-6 rounded-2xl border border-gray-200 bg-white h-full">
    <div className="text-4xl font-bold text-gray-300 mb-4">{number}</div>
    <div className={`mb-4 ${iconColorClass}`}>
      <Icon />
    </div>
    <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
    <p className="text-sm text-gray-700 leading-relaxed">{description}</p>
  </div>
);


export default function RegulatoryAffairsSuitePage() {
  return (
    <main data-testid="page-root" className="min-h-screen bg-gray-50 text-gray-900 font-sans">
      <header className="sticky top-0 z-40 backdrop-blur bg-white/80 border-b border-gray-200">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-7 w-7 rounded-lg bg-indigo-600" />
            <span className="font-semibold text-gray-900">DeepDocs • Regulatory & Quality Suite</span>
          </div>
          <nav className="hidden md:flex items-center gap-6 text-sm">
            <a data-testid="nav-how" href="#how" className="text-gray-600 hover:text-indigo-600 transition">How it works</a>
            <a data-testid="nav-modules" href="#modules" className="text-gray-600 hover:text-indigo-600 transition">Modules</a>
            <a data-testid="nav-sources" href="#sources" className="text-gray-600 hover:text-indigo-600 transition">Sources</a>
            <a data-testid="nav-security" href="#security" className="text-gray-600 hover:text-indigo-600 transition">Security</a>
            <a data-testid="nav-kpi" href="#kpi" className="text-gray-600 hover:text-indigo-600 transition">KPIs</a>
          </nav>
          <div className="flex items-center gap-2">
            <CTAButton testid="cta-demo-top" href="#demo">Start a live demo session</CTAButton>
          </div>
        </div>
      </header>
      <section className="relative overflow-hidden py-16 sm:py-24">
        <div className="absolute inset-0 z-0 opacity-10">
          <div className="w-full h-full bg-[radial-gradient(ellipse_at_bottom_right,_var(--tw-gradient-stops))] from-indigo-50 to-white via-transparent"></div>
        </div>
        <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
            <div className="max-w-xl mx-auto lg:mx-0">
              <Pill>Compliance, not complexity</Pill>
              <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-tight">
                Accelerate submissions and ensure end-to-end compliance.
              </h1>
              <p className="mt-4 text-lg text-gray-700">Streamline regulatory workflows from document creation to audit-ready submission packages.</p>
              <div className="mt-8 flex flex-wrap items-center gap-3">
                <CTAButton testid="cta-demo-hero" href="#demo" variant="primary">Start a live demo session</CTAButton>
                <CTAButton testid="cta-sample" href="#sample" variant="secondary">See a submission package sample</CTAButton>
              </div>
              <div className="mt-6 flex flex-wrap gap-2 text-xs text-gray-600">
                <Badge>Audit-ready outputs</Badge>
                <Badge>Version control</Badge>
                <Badge>Compliance check</Badge>
                <Badge>Automated logs</Badge>
              </div>
            </div>
            <div className="mt-12 lg:mt-0">
              <HeroVideoMockup />
            </div>
          </div>
        </div>
      </section>
      <section className="border-t border-gray-200 py-12 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-6">
            <Card testid="card-speed" title="Compliance by design" icon={<Shield />}>Automate regulatory checklists and ensure every document meets standards from day one.</Card>
            <Card testid="card-trace" title="Audit-Ready Logs" icon={<BookOpen />}>Maintain a complete, traceable history of every change, review, and approval for painless audits.</Card>
            <Card testid="card-cycles" title="Accelerate Submission" icon={<Zap />}>Detect and fix gaps in your technical documentation to reduce review cycles and expedite submissions.</Card>
          </div>
        </div>
      </section>
      <section className="border-t border-gray-200 bg-white py-12 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-xl font-semibold text-gray-800 mb-6">Trusted by regulatory teams at leading MedTech companies.</h2>
          <ClientLogos />
          <div className="mt-12">
            <Testimonial
              quote="DeepDocs streamlined our entire MDR submission process, cutting our time to market significantly."
              author="Regulatory Affairs Manager (EU)"
            />
          </div>
        </div>
      </section>
      <section id="sources" data-testid="section-sources" className="border-t border-gray-200 bg-gray-50 py-12 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-6 flex items-center gap-2">
            <Database />
            <h2 className="text-xl font-semibold">Sources & ingestion (private + expert databases)</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-6 text-sm leading-6">
            <Card testid="card-private" title="Private repositories" icon={<Shield />}>
              SharePoint • OneDrive/Drive • Confluence • S3/Blob • on‑prem file servers (secure connector)
            </Card>
            <Card testid="card-expert" title="Expert databases" icon={<Stars />}>
              <span className="font-medium">PubMed</span> • <span className="font-medium">Cochrane Library</span> • <span className="font-medium">Web of Science</span> • <span className="font-medium">Google Scholar</span> • <span className="font-medium">Embase</span> <span className="text-gray-500">(access/licensing via customer credentials)</span>
            </Card>
          </div>
          <p className="mt-6 text-sm text-gray-600">De‑duplication, metadata normalization, and PICO mapping included.</p>
        </div>
      </section>

      {/* How it Works - REDESIGNED INFOGRAPHIC SECTION */}
      <section id="how" data-testid="section-how" className="border-t border-gray-200 py-12 sm:py-20 bg-gray-50">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-semibold text-gray-900 mb-3">DeepDocs in 3 Simple Steps</h2>
          <p className="text-lg text-gray-600 mb-12">Seamless regulatory document generation.</p>
          <div className="relative grid md:grid-cols-3 gap-8 items-stretch">
            {/* Connecting Arrows/Lines */}
            <div className="absolute hidden md:flex top-1/2 left-1/3 -translate-y-1/2 w-1/3 h-1 bg-gray-200 z-0 justify-between items-center px-4">
              <ArrowRight className="text-gray-400 absolute left-0 ml-[-20px]" />
              <ArrowRight className="text-gray-400 absolute right-0 mr-[-20px]" />
            </div>
            <div className="absolute hidden md:flex top-1/2 left-2/3 -translate-y-1/2 w-1/3 h-1 bg-gray-200 z-0 justify-between items-center px-4">
              <ArrowRight className="text-gray-400 absolute left-0 ml-[-20px]" />
              <ArrowRight className="text-gray-400 absolute right-0 mr-[-20px]" />
            </div>
            <HowItWorksStep
              testid="factory-step-1"
              number="1"
              icon={FactoryIcon}
              iconColorClass="text-indigo-600"
              title="Select Your AI Factory"
              description="Choose a factory to automate CER, PMCF, CAPA, or your custom reports."
            />
            <HowItWorksStep
              testid="factory-step-2"
              number="2"
              icon={InputConfigIcon}
              iconColorClass="text-teal-500"
              title="Define Your Inputs"
              description="Pick sources, regulatory standards (MDR, FDA), and templates."
            />
            <HowItWorksStep
              testid="factory-step-3"
              number="3"
              icon={ProcessExportIcon}
              iconColorClass="text-indigo-600"
              title="Process, Approve & Export"
              description="Validate, review, and export audit-ready documents with traceable logs."
            />
          </div>
        </div>
      </section>

      {/* Modules */}
      <section id="modules" data-testid="section-modules" className="border-t border-gray-200 bg-gray-50 py-12 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <h2 className="text-xl font-semibold mb-6">What’s inside the Regulatory & Quality Suite</h2>
          <div className="grid md:grid-cols-2 xl:grid-cols-5 gap-6">
            <Card testid="mod-assess" title="DAM Assess" icon={<Check />}>MEDDEV, IMDRF, ISO scoring & justification logs.</Card>
            <Card testid="mod-compare" title="DeepCompare" icon={<Compare />}>Track dossier revisions across submission cycles.</Card>
            <Card testid="mod-similarity" title="DeepSimilarity" icon={<Stars />}>Align IFU, labeling and submission texts.</Card>
            <Card testid="mod-factory" title="Custom Factory" icon={<Zap />}>Automate CER, PMCF, CAPA reports, risk-management files.</Card>
            <Card testid="mod-compliance" title="Regulatory Check" icon={<Shield />}>Validate technical documentation before submission.</Card>
          </div>
        </div>
      </section>
      <section id="sample" data-testid="section-sample" className="border-t border-gray-200 py-12 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-3 flex items-center gap-2">
            <h2 className="text-xl font-semibold">Regulatory & Quality Spotlight</h2>
            <Badge>EU MDR</Badge><Badge>FDA</Badge>
          </div>
          <div className="text-sm text-gray-700">
            <div className="flex flex-wrap gap-2 mb-3">
              <Badge>CER</Badge><Badge>PMCF</Badge><Badge>CAPA</Badge><Badge>Risk-Management</Badge>
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <Card testid="sample-fields" title="Validation fields" icon={<Check />}>Missing sections • Outdated references • Misaligned data across annexes</Card>
              <Card testid="sample-deliver" title="Deliverables" icon={<BookOpen />}>Audit-ready documents • CER/PMCF/CAPA reports • Submission-ready packages</Card>
            </div>
          </div>
        </div>
      </section>
      <section id="security" data-testid="section-security" className="border-t border-gray-200 bg-gray-50 py-12 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-6">
            <Card testid="sec-deploy" title="Deployment" icon={<Shield />}>Cloud, plug‑and‑play (start same day). On‑prem / single‑tenant available.</Card>
            <Card testid="sec-controls" title="Controls" icon={<Shield />}>SSO/RBAC • encryption in transit/at rest • audit logs • approval gates.</Card>
            <Card testid="sec-gov" title="Governance" icon={<Shield />}>Aligns to your SOPs; supports FDA/EMA‑grade rigor and documented approvals.</Card>
          </div>
        </div>
      </section>

      {/* KPIs - REUSED KPI SECTION */}
      <section id="kpi" data-testid="section-kpi" className="border-t border-gray-200 py-12 sm:py-20 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-semibold text-gray-900 mb-3">Demonstrate Impact: Key Performance Indicators</h2>
          <p className="text-lg text-gray-600 mb-12">Quantifiable results that leadership will appreciate.</p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
            <KPICard
              testid="kpi-speed"
              icon={BoltIcon}
              iconColorClass="text-teal-500"
              title="Accelerated Drafts"
              description="Query to first submission draft in 24 hours"
            />
            <KPICard
              testid="kpi-agreement"
              icon={AgreementIcon}
              iconColorClass="text-indigo-600"
              title="Increased Agreement Rate"
              description="Enhanced consensus on regulatory interpretations"
            />
            <KPICard
              testid="kpi-cycles"
              icon={ReduceCyclesIcon}
              iconColorClass="text-indigo-600"
              title="Reduced Review Cycles"
              description="Streamlined approvals for technical documentation"
            />
            <KPICard
              testid="kpi-reuse"
              icon={ReuseIcon}
              iconColorClass="text-teal-500"
              title="Content Reuse Rate"
              description="Maximized content leverage across regulatory submissions"
            />
            <KPICard
              testid="kpi-logs"
              icon={AuditReadyIcon}
              iconColorClass="text-teal-500"
              title="100% Audit-Ready Logs"
              description="Complete and traceable deliverables for regulatory scrutiny"
            />
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section id="demo" data-testid="section-demo" className="border-t border-gray-200 bg-gray-900 text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
          <h2 className="text-3xl font-semibold">Ready to see high‑precision compliance — live?</h2>
          <p className="mt-2 text-white/80">We’ll use your dossier and map it against the latest regulatory guidance.</p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <a data-testid="cta-demo-bottom" href="#" className="inline-flex items-center gap-2 rounded-xl bg-indigo-500 text-white px-4 py-2 text-sm font-semibold hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-900 transition">Start a live demo session <ArrowRight /></a>
            <a data-testid="cta-expert-bottom" href="#contact" className="inline-flex items-center gap-2 rounded-xl border border-gray-700 px-4 py-2 text-sm font-semibold text-gray-300 hover:bg-white/10 transition">Talk to an expert <ArrowRight /></a>
          </div>
          <p className="mt-6 text-xs text-white/50">Deployment path: Cloud plug‑and‑play day one; on‑prem/single‑tenant available.</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-gray-200">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 text-xs text-gray-600 flex flex-wrap gap-4 items-center justify-between">
          <div>© {new Date().getFullYear()} DeepDocs AI — Regulatory & Quality Suite</div>
          <div className="flex items-center gap-3">
            <a href="#how" className="hover:underline">How it works</a>
            <a href="#sources" className="hover:underline">Sources</a>
            <a href="#security" className="hover:underline">Security</a>
            <a href="#kpi" className="hover:underline">KPIs</a>
          </div>
        </div>
      </footer>
    </main>
  );
}
